import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrivateRouteWithAuth = ({ component: Component, ...rest }) => {
  const { auth } = rest;
  // console.log(`LOG === ${rest}`);
  return (
    <Route
      {...rest}
      render={props =>
      (auth.checkPermission(rest.permissionsAllowed) ? (
        <Component {...props} {...rest} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
          }}
        />
      ))
      }
    />
  );
};

PrivateRouteWithAuth.defaultProps = {
  permissionsAllowed: [],
};

PrivateRouteWithAuth.propTypes = {
  component: PropTypes.func.isRequired,
  permissionsAllowed: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateRouteWithAuth;



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/PrivateRouteWithAuth.jsx